import { useContext } from "react";

import { ClientsContext } from "src/contexts/clients.context";

import useTranslate from "src/hooks/use-translate";

import "./delete-sub-tab.style.scss";

const DeleteSubTap = ({ id }) => {
	const { downloadClient, deleteClient } = useContext(ClientsContext);
	const t = useTranslate("");

	const handleDownload = () => {
		downloadClient(id);
	};

	const handleDelete = () => {
		deleteClient(id);
	};

	return (
		<div className="people-sub-category-container padding-m--left">
			<p className="size400 w600 with-line margin-l--bottom">{t("Delete Client")}</p>
			<p className="size300 w400 margin-xxl--bottom">
				{t(
					"Deleting Client’s account will remove all of their records and information from C&D Compta’s METI Box database. Please inform your client that this cannot be undone."
				)}
			</p>
			<p className="size300 w600 margin-s--bottom">{t("Client’s Data")}</p>
			<p className="size300 w400 margin-l--bottom">
				{t(
					"Download all records and information related to the Client before deleting their account permanently."
				)}
			</p>
			<span className="button-container flex gap-l">
				<button
					onClick={handleDownload}
					className="w500 flex--grow border smooth-corners padding-xs--block"
				>
					{t("Download")}
				</button>
				<button
					onClick={handleDelete}
					className="w500 flex--grow border smooth-corners padding-xs--block btn-delete"
				>
					{t("Continue")}
				</button>
			</span>
		</div>
	);
};

export default DeleteSubTap;
